import { SunspotLoader } from 'react-awesome-loaders'

const Loader = () => {
    return (
        <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
            }}
        >
            <SunspotLoader
                gradientColors={['#6366F1', '#E0E7FF']}
                shadowColor={'#3730A3'}
                desktopSize={'30px'}
                mobileSize={'20px'}
            />
        </div>
    );
};

export default Loader;